module.exports = __webpack_public_path__ + "static/media/code_1.69.2-1658162013_amd64.720cbe69.deb";